// @ts-strict-ignore
import {AttrsSchema, Component, h} from 'panel';
import MarkdownIt from 'markdown-it';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {MarkdownAttrs, MarkdownJsxProps} from './types';
import styles from './index.module.styl';

export class Markdown extends Component<EmptyObj, MarkdownAttrs> {
  declare converter: any;

  static get attrsSchema(): AttrsSchema<MarkdownAttrs> {
    return {
      ...super.attrsSchema,
      text: {type: `string`, description: `Markdown formatted text to be processed and rendered as HTML`},
      'allow-breaks': {type: `boolean`, description: `Allow new line characters to be treated as breaks`},
      'multi-line': {type: `boolean`, description: `Allow multiple lines of markdown`},
    };
  }

  get config() {
    return {
      template: () => h(`div.${styles.container}`),
      defaultState: {},
      helpers: {},
    };
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    super.attributeChangedCallback(attr, oldValue, newValue);
    if (!this.initialized) {
      return;
    }
    if (attr === `text`) {
      // The markdown library we're using handles the sanitization for us.
      // eslint-disable-next-line no-unsanitized/property
      this.el.children[0].innerHTML = this.getMarkup();
    }
  }

  connectedCallback() {
    super.connectedCallback();
    // The markdown library we're using handles the sanitization for us.
    // eslint-disable-next-line no-unsanitized/property
    this.el.children[0].innerHTML = this.getMarkup();
  }

  constructor() {
    super();

    if (this.attr(`allow-breaks`)) {
      this.converter = new MarkdownIt(`default`, {breaks: true});
    } else {
      this.converter = new MarkdownIt();
    }

    // adds blank targets to all links
    this.converter.renderer.rules.link_open = function (tokens, idx, options, _env, self) {
      if (tokens[idx].tag === `a`) {
        tokens[idx].attrPush([`target`, `_blank`]);
        tokens[idx].attrPush([`rel`, `noreferrer noopener`]);
      }
      // pass token to default renderer.
      return self.renderToken(tokens, idx, options);
    };
  }

  getMarkup() {
    const markdownText = this.attr(`text`);

    if (this.attr(`multi-line`)) {
      return this.converter.render(markdownText).trim();
    }

    return this.converter.renderInline(markdownText).trim();
  }
}

export const MarkdownEl = defineAndMakeJsxFactory<MarkdownJsxProps>(`mp-markdown`, Markdown);
export const MarkdownReact = panel2react<MarkdownJsxProps>(`mp-markdown`, Markdown);
